import { BehaviorSubject } from 'rxjs';

export namespace PrivacyState {
    export const isAnyDisallowed$ = new BehaviorSubject(false);
    export const isCoreAllowed$ = new BehaviorSubject(true);
    export const isPerformanceAllowed$ = new BehaviorSubject(true);
    export const isPersonalisationAllowed$ = new BehaviorSubject(true);
}
